var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgFiletypeRevit(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm11 3v-3h-9v16h12v-13z', fill: '#005a92' }),
        React.createElement("path", { d: 'm7.6 9.4 2.72 3.12 1.68-.08-3.2-3.68c1.29734-.34383.96-2.16.96-2.16a3.062 3.062 0 0 0 -2.8-2.56l-2.96.08 2.48 8.88 1.6-.16-1.04-3.68a.74352.74352 0 0 1 .56.24zm-.96-1.52-.64-2.32a3.183 3.183 0 0 1 .88-.08 1.42419 1.42419 0 0 1 1.44 1.28.76471.76471 0 0 1 -.64 1.04z', fill: '#fff', fillRule: 'evenodd' }),
        React.createElement("path", { d: 'm11 0 3 3h-3z', fill: '#003f66' })));
}
export default SvgFiletypeRevit;
